/**
 * Community connections list — used to resolve memberSub for trip share invites.
 */

import { API_BASE_URL, buildAuthHeaders } from './apiClient';

export interface ConnectionRow {
  connectedUserId: string;
  displayName?: string | null;
  username?: string | null;
}

function asRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' && !Array.isArray(value)
    ? (value as Record<string, unknown>)
    : {};
}

export function parseConnection(raw: unknown): ConnectionRow {
  const o = asRecord(raw);
  const connectedUserId = String(
    o.connectedUserId ?? o.connected_user_id ?? o.userId ?? o.sub ?? ''
  );
  return {
    connectedUserId,
    displayName: o.displayName != null ? String(o.displayName) : null,
    username: o.username != null ? String(o.username) : null,
  };
}

export async function listConnections(): Promise<ConnectionRow[]> {
  const headers = await buildAuthHeaders();
  const res = await fetch(`${API_BASE_URL}/community/connections`, {
    method: 'GET',
    headers,
  });
  if (!res.ok) {
    throw new Error(`Failed to load connections (${res.status})`);
  }
  const json = await res.json();
  const rows = Array.isArray(json) ? json : Array.isArray(json?.connections) ? json.connections : [];
  return rows.map(parseConnection).filter((c: ConnectionRow) => !!c.connectedUserId);
}
